import {getRunningTimeDuration} from '@domain/running-times'
import {RunningTime, RunningTimeType} from '@hconnect/common/types'
import {FiberManualRecord as Circle} from '@mui/icons-material'
import {Stack, Typography} from '@mui/material'
import {RUNNING_TIME_COLOR} from '@widgets/common-running-times'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

type RuntimeSplitDurationDetailsProps = {
  runningTimes: RunningTime[]
  timezone: string
}

export const RuntimeSplitDurationDetails = ({
  runningTimes,
  timezone
}: RuntimeSplitDurationDetailsProps) => {
  const {
    t,
    i18n: {language}
  } = useTranslation(FEATURE_NAMESPACE)

  return (
    <Stack gap={1} width="100%">
      {runningTimes.map(({runningTimeType, beginTechnical, endTechnical}, index) => (
        <Stack data-test-id={`split-runtimes-${index}`} key={`split-runtimes-${index}`}>
          <Typography variant="caption">
            {t('splitDurationDetails.label.part', {
              index: index + 1
            })}
          </Typography>
          <Typography variant="subtitle1">
            <Circle
              sx={{
                color:
                  runningTimeType === RunningTimeType.RUNNING
                    ? RUNNING_TIME_COLOR.running
                    : RUNNING_TIME_COLOR.stoppedUndefined,
                verticalAlign: 'text-bottom',
                height: 20,
                width: 20,
                mr: 0.75
              }}
            />
            {getRunningTimeDuration({
              beginUtc: beginTechnical?.toISOString(),
              endUtc: endTechnical?.toISOString(),
              translationFn: t,
              timezone,
              language
            })}
          </Typography>
        </Stack>
      ))}
    </Stack>
  )
}
